import { colors } from './colors';
import { windowSize } from './windowSize';
import { fontSize } from './fontSize';
import { Theme } from '@emotion/react';

export const theme: Theme = {
  colors: colors,
  windowSize: windowSize,
  fontSize: fontSize,
};
